
import { VideoResponses } from "./VideoResponses";
import { Profile } from "@/hooks/useProfile";
import { useVideoResponses } from "@/hooks/useVideoResponses";
import { LazyVideo } from "./LazyVideo";

interface VideoResponsesTabProps {
  profile: Profile;
}

export const VideoResponsesTab = ({ profile }: VideoResponsesTabProps) => {
  const { videoResponses, loading } = useVideoResponses();

  if (loading) {
    return (
      <div className="space-y-3">
        <h3 className="text-base font-semibold text-green-800">My Video Responses</h3>
        <div className="text-center py-8 text-gray-500">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-sm">Loading your video responses...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <h3 className="text-base font-semibold text-green-800">My Video Responses</h3>
      
      {videoResponses.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p className="text-sm">You haven't created any video responses yet.</p>
          <p className="text-xs mt-2">Start engaging with posts to share your farming experiences!</p>
        </div>
      ) : (
        <div className="space-y-4">
          {videoResponses.map((response) => (
            <div key={response.id} className="bg-white rounded-lg border border-gray-200 p-4">
              <div className="mb-3">
                <LazyVideo
                  src={response.video_url}
                  className="w-full h-32 object-cover rounded"
                  width={320}
                  height={128}
                  controls={true}
                  muted
                  postId={response.id}
                />
              </div>
              
              {response.response_text && (
                <p className="text-sm text-gray-800 mb-2">{response.response_text}</p>
              )}
              
              <div className="flex items-center justify-between text-xs text-gray-500">
                <span>Posted on {new Date(response.created_at).toLocaleDateString()}</span>
                <span>{response.likes_count} likes</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
